import styled from 'styled-components';

import { scrollbarX } from 'shared/styles/commonStyles';

// Recharts draws the Y axis inside the same <svg> as the plot, so scrolling a
// widened chart carries its axis off screen and the reader loses the scale.
// The axis is therefore rendered a second time and pinned here with
// position:sticky. Keeping it inside the scroll container rather than floating
// it above means it shares the chart's height exactly, so the two can never
// drift out of vertical alignment.
const AXIS_WIDTH = 60;

const ChartViewport = ({ scale, axis, children }) => (
  <Viewport>
    <Row $scale={scale}>
      {axis && (
        <StickyAxis>
          <AxisInner>{axis}</AxisInner>
        </StickyAxis>
      )}
      <Track>{children}</Track>
    </Row>
  </Viewport>
);

export default ChartViewport;

const Viewport = styled.div`
  width: 100%;
  height: 100%;
  ${scrollbarX};
`;

const Row = styled.div`
  width: ${({ $scale }) => $scale * 100}%;
  height: 100%;
  display: flex;
`;

const StickyAxis = styled.div`
  position: sticky;
  left: 0;
  z-index: 2;
  flex: 0 0 ${AXIS_WIDTH}px;
  height: 100%;

  // Opaque so the plot scrolls behind the ticks rather than through them.
  background: #233a54;
  overflow: hidden;
  pointer-events: none;
`;

// Recharts needs room to lay a chart out before it will draw an axis, so the
// axis-only copy is given a workable width and clipped back to the axis by
// StickyAxis.
const AxisInner = styled.div`
  width: 200px;
  height: 100%;
`;

const Track = styled.div`
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
`;
